<template>
  <div>
      <div class="mod_tit_linethrough">
            <fieldset class="tit_info">
                <legend class="tit">赠片规则</legend>
            </fieldset>
        </div>
        <div class="mod_rule_list">
            <div class="rule_list">
                <p class="txt">1. 抢到影片之后，即可在腾讯视频登录帐号免费观看，观影有效期为2天。</p>
                <p class="txt">2. 赠送影片为腾讯视频VIP特权，等级越高每月获得赠片次数越多。
                  <template v-if="!isApp()">
                    <template v-if="payVipInfo && payVipInfo.vip"><a class="link" href="//film.qq.com/weixin/giverecord.html">查看我的赠片资格</a>。</template>
                    <template v-else><a class="link" @click="goToPay">开通腾讯视频VIP</a>。</template>
                  </template></p>
                <p class="txt">3. 每次赠送消耗1次赠片机会（支持微信好友、朋友圈、QQ空间、微博，同部影片只消耗1次赠片资格），可由5位好友领取，先到先得。</p>
                <p class="txt">4. 选择领取帐号，领取后登录才能观看哟。</p>
            </div>
        </div>
  </div>

</template>

<script>

export default {
  data () {
    return {

    }
  }
}
</script>
